import { type UiTooltip } from "various-ui";
//* 组件属性
import { useOptions } from "./options";

export const useComposable = () => {
    //* 配置项
    const options = useOptions();

    //* 响应式变量
    const refs = {
        visible: ref<boolean>(false),
    };

    //* 节点
    const nodes = {
        container: ref<HTMLDivElement>(),
        tooltip: ref<InstanceType<typeof UiTooltip>>(),
    };

    //* 函数列表
    const methods = {
        hidden: () => {
            if (refs.visible.value) {
                nodes.tooltip.value?.hidden();
            } else {
                nodes.tooltip.value?.show();
            }
        },
    };

    //* 动态属性
    const binds = reactive({
        visible: computed(() => {
            return {
                direction: "bottom" as "bottom",
                trigger: "click" as "click",
                align: "center" as "center",
                width: 664,
                zIndex: 667,
            };
        }),
    });

    //* 响应事件
    const ons = {
        visible: {
            "before-enter": () => (refs.visible.value = true),
            "after-leave": () => (refs.visible.value = false),
        },
    };

    return { ons, refs, nodes, binds, methods, options };
};
